import * as moment from 'moment';
import {ActionCompletionDialogComponent} from '../../common/action-completion-dialog/action-completion-dialog.component';
import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {IOrderDetails} from '../../models/models';
import {LoadingService} from '../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {PurchaseOrdersService} from '../../services/purchase-orders.service';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  styleUrls: ['./create-loading-accessory-request.component.scss'],
  templateUrl: './create-loading-accessory-request.component.html'
})
export class CreateLoadingAccessoryRequestComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;

  private selectedSalePoint: any;
  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public firstFormGroup: FormGroup;
  public isLinear: true;
  public loadingOrderDetailsColumns: string[];
  public orderData: any;
  public orderSelection: SelectionModel<IOrderDetails>;
  public poDetailsDataSource = new MatTableDataSource<any>();
  public secondFormGroup: FormGroup;
  public selectRecipients: FormGroup;
  public selection: SelectionModel<any>;
  public title: string;

  constructor(private commonService: CommonService,
              private formBuilder: FormBuilder,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<CreateLoadingAccessoryRequestComponent>,
              private purchaseOrdersService: PurchaseOrdersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    const type = `Αριθμό Αίτησης ${this.data.order_id}`;
    this.title = `Νέα Εντολή Φόρτωσης για τον ${type}`;

    this.loadingOrderDetailsColumns = ['select', 'serial_number', 'material_id', 'material_description'];

    this.displayedColumns = ['select', 'name', 'role_name', 'status_name'];

    this.selection = new SelectionModel<any>(true, []);
    this.orderSelection = new SelectionModel<IOrderDetails>(true, []);

    this.matDialogRef.updateSize('300px', '550px');
    this.orderData = [];
  }

  public ngOnInit(): void {
    this.selectRecipients = this.formBuilder.group({
        delivery_date: ['', Validators.required]
      });
    this.firstFormGroup = this.formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.selectRecipients.controls.delivery_date.setValue(tomorrow);
  }

  public applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  private initPaginatorAndSort() {
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.dataSource.sort = this.sort;
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    // @ts-ignore
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public isAllOrdersSelected(): boolean {
    const numSelected = this.orderSelection.selected.length;
    // @ts-ignore
    const numRows = this.poDetailsDataSource.data.length;
    return numSelected === numRows;
  }

  public masterToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  public masterOrderToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.orderSelection.clear() : this.poDetailsDataSource.data.forEach((row) => this.orderSelection.select(row));
  }

  selectRow() {
    this.selection.clear();
  }

  isRecipientFormValid(): boolean {
    return !this.selectRecipients.valid;
  }

  public async next() {

    if (this.stepper.selectedIndex === 0) {
        const users = this.data.users.filter(u => u.status_value === 1);
        this.dataSource = new MatTableDataSource<any>(users);
        this.initPaginatorAndSort();
        this.stepper.next();
    } else if (this.stepper.selectedIndex === 1) {
      this.selectedSalePoint = this.selection.selected;
      try {
          this.loadingService.show();
          const data = await this.commonService.getSimpleList(`accessory_request/${this.data.order_id}/serial_numbers`) as any;
          this.poDetailsDataSource.data = data;
          this.loadingService.hide();
          this.stepper.next();
        } catch (e) {
        } finally {
          this.loadingService.hide();
        }
    }
  }

  checkboxLabel(row?: IOrderDetails): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.orderSelection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  public previous() {
    if (this.stepper.selectedIndex === 1) {
      this.selection.clear();
      this.stepper.previous();
    } else if (this.stepper.selectedIndex === 2) {
      this.stepper.previous();
    }
  }

  public isLoadingValid(): boolean {
    return this.orderSelection.selected.length <= 0;
  }

  isRecipientsValid(): boolean {
    return this.selection.selected.length === 0;
  }

  public async submitLoading() {
    this.loadingService.show();
    const loadingModel = {
      user_id: this.selectedSalePoint[0].id,
      request_id: this.data.order_id,
      sale_point_id: this.data.sale_point_id,
      desired_delivery_date: moment(this.selectRecipients.get('delivery_date').value).format('YYYY-MM-DD'),
      details: this.orderSelection.selected
    };
    try {
     const result = await this.commonService.insertObject('accessory_request/loading_command', loadingModel);
     this.loadingService.hide();
     this.matDialogRef.close(result);

     this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις εντολές φόρτωσης θηκών',
          redirectURL: `accessory_loading_commands`
        }
      });
     this.loadingService.hide();
    } catch (e) {
      this.loadingService.hide();
      this.matDialogRef.close();
    }
  }

  selectRow1(row: any) {
    const oldSelected = this.selection.selected;
    if (oldSelected.length > 0) {
      this.selection.clear();
      this.selection.toggle(row);
    }
    if (oldSelected[0] === row || oldSelected.length === 0) {
      this.selection.toggle(row);
    }
  }
}
